import React from 'react'
import { Trans } from '@lingui/react'

import createFormValidation from '../../../util/createFormValidation'
import useFormState from '../../hooks/useFormState'

const INITIAL_VALUES = {
    description: '',
    key: '',
}

const validation = createFormValidation([
    {
        path: 'description',
        validate: (description) => description.length > 10,
        message: <Trans id="Minimum 10 characters" />,
    },
])

const valuesToInput = (values) => values

const useTenantSelectionImpersonationForm = (initialValues, options) =>
    useFormState(
        {
            ...INITIAL_VALUES,
            ...initialValues,
        },
        {
            validation,
            valuesToInput,
            ...options,
        },
    )

export default useTenantSelectionImpersonationForm
